//angular imports
import {
  TemplateRef,
  Component,
  OnDestroy,
  WritableSignal,
  signal,
  ChangeDetectionStrategy
} from '@angular/core';

//ngx-bootstrap imports
import {
  BsModalRef,
  BsModalService,
  ModalOptions
} from 'ngx-bootstrap/modal';

//local

import {
  CloseDialogMessage,
  Messenger
} from '@app/shared';

//local imports
import { PresenterType } from "@app/shared";
import { CatalogHeaderModel } from '@app/catalog';

@PresenterType(
{
    model: CatalogHeaderModel 
})
@Component({
    selector: 'catalog-header',
    templateUrl: './catalog-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogHeaderComponent implements OnDestroy {
    public data: WritableSignal<CatalogHeaderModel> = signal<CatalogHeaderModel>(null);

    public bsModalRef?: BsModalRef;

    constructor(
      private messenger: Messenger,
      private modalService: BsModalService) 
    {           
      this.messenger.subscribe(this, CloseDialogMessage, msg => {

        //if (msg.handled) return;
  
        //TODO:DIW:Check CloseDialogMessage + show toast.
        this.bsModalRef?.hide();
  
        msg.handled = true;
      });
    } 

    public openForm(template: TemplateRef<void>) {
      const initialState: ModalOptions = {
        class: 'form-modal',
      };
      this.bsModalRef = this.modalService.show(template, initialState);
    }

    ngOnDestroy(): void {
      this.messenger.unsubscribeByOwner(this);
    }
}